export default {
  methods: {
    async preventEntering(message) {
      await this.$router.push({
        name: 'NotFound',
        params: {
          errorMessage: message || null,
        },
      });
    },
  },
};
